import { Component, OnInit  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { WebSocketService } from '../../../web-socket.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { TabService } from './../../../tab.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],

})

export class LoginComponent  implements OnInit{

  public show: boolean = false;
  idOrganizacao: string = '';
  public loginForm: FormGroup;
  public isLoading:boolean = false;
  public nomeEmpresa: string = '';
  public apiVersion: string = '';

  constructor(private fb: FormBuilder, private webSocketService: WebSocketService, public router: Router,  private http: HttpClient, public  tabService: TabService) {

    this.load();
    const userData = localStorage.getItem('token');
      if(userData?.length != null){
        router.navigate(['/'])
      }

    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", Validators.required],
    });

  }

  ngOnInit(): void {
    this.loadGitHash();
  }

  loadGitHash(): void {
    this.http.get<{ gitHash: string }>('assets/git-version.json').subscribe(
      (data) => {
        // Pega os 7 primeiros dígitos do git hash (ou o valor completo se tiver menos de 7 caracteres)
        this.apiVersion = data.gitHash.length >= 7 ? data.gitHash.slice(0, 7) : data.gitHash;
        console.log('Git hash:', this.apiVersion);
      },
      (error) => {
        console.error('Erro ao carregar o git hash:', error);
        this.apiVersion = 'N/A'; // Valor padrão em caso de erro
      }
    );
  }

  load(){

    this.http.get<any>(`${environment.apiUrl}/domain` ).subscribe(
      (response) => {
        console.log( response)
        if(response.nomeFantasia == null || response == ''){
          this.router.navigateByUrl("/sign-up");
        }
        this.nomeEmpresa = response.nomeFantasia;
        //this.apiVersion = localStorage.getItem('apiVersion') ?? 'N/A';; 
      },
      (error) => {
        alert('O domínio solicitado não existe, mas você pode se cadastrar!');
        this.router.navigateByUrl("/sign-up");
      });
  }



  showPassword() {
    this.show = !this.show;
  }

  login() {
      const body = {
        email: this.loginForm.value["email"],
        senha: this.loginForm.value["password"]
      };

      this.tabService.closeAllTabs();
      this.isLoading = true;
      this.http.post<any>(`${environment.apiUrl}/login`, body).subscribe((response) => {
        console.log(response);
        console.log('accessToken token', response.accessToken);
        localStorage.setItem('token', response.accessToken);

        this.http.get<any>(`${environment.apiUrl}/usuario/logado`).subscribe((response) => {
          console.log('operadorResponse', response);
          this.idOrganizacao = response.idEmpresaPadrao;
          localStorage.setItem('username', response.email);
          localStorage.setItem('idOrganizacao', this.idOrganizacao);
          localStorage.setItem('nomeUsuario', response.nome);
          localStorage.setItem('empresa', response.empresa);
          localStorage.setItem('idUsuario', response.idUsuario);

          //Connect to WebSocket here
          this.webSocketService.connect();

          let user = {
            email: this.loginForm.value["email"],
            password: "test123",
            name: response.nome,
          };
          localStorage.setItem("user", JSON.stringify(user));

          // Verifica se existe uma URL de redirecionamento
          const redirectUrl = localStorage.getItem('redirectUrl');
          if (redirectUrl) {
            localStorage.removeItem('redirectUrl'); // Remove a URL do localStorage
            this.router.navigateByUrl(redirectUrl);
          } else {
            this.router.navigate(["/"]);
          }
          
          console.log('this.router.navigate(["/dashboard"]);');
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          console.error('Error:', error);
        });
    }
    , (error) => {
          this.isLoading = false;
          console.error('Error:', error);
    });
  }

  public throwTestError(): void {
    throw new Error("Sentry Test Error");
  }

}
